// removed by extract-text-webpack-plugin
module.exports = {"plotLegend":"plot-legend-module__plotLegend___loK1v","legendTable":"plot-legend-module__legendTable___1S4s1","legendRow":"plot-legend-module__legendRow___1I207","legendBlock":"plot-legend-module__legendBlock___1rB2r","legendLabel":"plot-legend-module__legendLabel___3hJZI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/plot-legend/plot-legend.module.scss
// module id = 344
// module chunks = 0